<template>
    <input
      id="file-input"
      class="hide-file-input"
      type="file"
      accept="image/*"
      @change="onFileChange($event)"
    />
</template>
<script>
const action = {
  valdateImage(file){
    
    let allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];

    if (!file) {
      return "Please select an image file"; 
    }
    else if (!allowedTypes.includes(file.type)) {
      return "Invalid file type. Only jpeg, png, and gif are allowed."; 
    }
    else if (file.size > 8000000) {
        return  "File size too large. Maximum size is 8MB.";
    }
    else{
      return "";
    }
  }
}

export default {
  methods: {
    onFileChange($event) {
      const file = $event.target.files[0]
      const reader = new FileReader();
      const validate = action.valdateImage(file);
      if (validate == "") {
        reader.readAsDataURL(file)
        reader.onload = () => {
          // Set a new property on the captured `file` and set it to the converted base64 image
          file.previewBase64 = reader.result
          // Emit the file with the new previewBase64 property on it
          this.$emit('file-updated', file)
        }
        reader.onerror = (error) => {
          
        }
      }
      else{
        this.$notify({
          type: 'info',
          message: validate
        })
      }
    }
  }
}
</script>